import { render, staticRenderFns } from "./PetitionDialogContent.vue?vue&type=template&id=e1f7b92a&scoped=true"
import script from "./PetitionDialogContent.vue?vue&type=script&lang=ts"
export * from "./PetitionDialogContent.vue?vue&type=script&lang=ts"
import style0 from "./PetitionDialogContent.vue?vue&type=style&index=0&id=e1f7b92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f7b92a",
  null
  
)

export default component.exports